import { c as _c } from "react/compiler-runtime";
import { VillaSearchPassengerCountPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-passenger-count/villa-search-passenger-count.types";
import { MaterialIcon } from "@website/icons/material";
import { CounterButton } from "@website/ui/counter-button";
import pick from "lodash-es/pick";
import { useState } from "react";
export const useVillaSearchPassengerCount = properties => {
  const $ = _c(22);
  const {
    onSubmit,
    result,
    title,
    list,
    validation
  } = properties;
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onClickChips = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpen(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClosePopover = t1;
  let t2;
  if ($[2] !== onSubmit) {
    t2 = () => {
      onClosePopover();
      onSubmit();
    };
    $[2] = onSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onClickSubmit = t2;
  let t3;
  if ($[4] !== onClickSubmit) {
    t3 = {
      onClick: onClickSubmit,
      color: "secondary" as const,
      size: "large" as const,
      fullWidth: true,
      submitText: "\u062A\u0627\u06CC\u06CC\u062F"
    };
    $[4] = onClickSubmit;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon name="arrow_drop_down" variant="fill" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== result) {
    t5 = {
      variant: "outline" as const,
      EndIcon: t4,
      text: result,
      selected: true,
      color: "secondary" as const,
      onClick: onClickChips
    };
    $[7] = result;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== open || $[10] !== title) {
    t6 = {
      onClose: onClosePopover,
      open,
      title
    };
    $[9] = open;
    $[10] = title;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      text: "\u0633\u0642\u0641 \u0645\u062C\u0645\u0648\u0639 \u062A\u0639\u062F\u0627\u062F \u0645\u0633\u0627\u0641\u0631 \u0628\u0631\u0627\u06CC \u0647\u0631 \u0627\u062A\u0627\u0642 \u06F1\u06F5 \u0646\u0641\u0631 \u0645\u06CC \u0628\u0627\u0634\u062F."
    };
    t8 = {
      text: "\u0633\u0642\u0641 \u062A\u0639\u062F\u0627\u062F \u06A9\u0648\u062F\u06A9 \u0628\u0647 \u0627\u0632\u0627\u06CC \u0647\u0631 \u0628\u0632\u0631\u06AF\u0633\u0627\u0644 \u06F1\u06F2 \u0646\u0641\u0631 \u0645\u06CC \u0628\u0627\u0634\u062F"
    };
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== list) {
    t9 = list.map(_temp);
    $[14] = list;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t5 || $[18] !== t6 || $[19] !== t9 || $[20] !== validation) {
    t10 = {
      submitButtonProps: t3,
      chipsProps: t5,
      popoverProps: t6,
      validation,
      miniChipsPassenger: t7,
      miniChipsChildren: t8,
      list: t9
    };
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t9;
    $[20] = validation;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
function _temp(item) {
  return {
    title: item.title,
    subtitle: item.subtitle,
    role: "default",
    EndAction: <CounterButton color="secondary" variant="outline" {...pick(item, "decreaseDisabled", "increaseDisabled", "onChange")} locale="fa" value={item.value} />
  };
}